(function () {
  var guide = document.querySelector('.repair-guide');
  if (!guide) return;

  var titleEl = guide.querySelector('h1');
  var name = titleEl ? titleEl.textContent.trim() : document.title;

  var introEl = guide.querySelector('.repair-intro');
  var description = introEl ? introEl.textContent.trim() : '';

  var totalTime = '';
  var metaBoxes = guide.querySelectorAll('.repair-meta-box');
  for (var m = 0; m < metaBoxes.length; m++) {
    var label = metaBoxes[m].querySelector('strong');
    var value = metaBoxes[m].querySelector('span');
    if (label && value && /zeitaufwand/i.test(label.textContent)) {
      var numbers = value.textContent.match(/\d+/g);
      if (numbers && numbers.length) {
        var max = Math.max.apply(null, numbers.map(Number));
        totalTime = 'PT' + max + 'M';
      }
    }
  }

  var tools = [];
  var toolItems = guide.querySelectorAll('.repair-tools li');
  for (var t = 0; t < toolItems.length; t++) {
    var toolText = toolItems[t].textContent.trim();
    if (toolText) tools.push({ '@type': 'HowToTool', name: toolText });
  }

  var steps = [];
  var stepEls = guide.querySelectorAll('.repair-step');
  for (var s = 0; s < stepEls.length; s++) {
    var stepEl = stepEls[s];
    var stepTitleEl = stepEl.querySelector('.repair-step-title');
    var imgEl = stepEl.querySelector('.repair-step-image img');
    var paragraphs = stepEl.querySelectorAll('p');
    var textParts = [];
    for (var p = 0; p < paragraphs.length; p++) {
      var t2 = paragraphs[p].textContent.trim();
      if (t2) textParts.push(t2);
    }

    var step = {
      '@type': 'HowToStep',
      position: s + 1,
      name: stepTitleEl ? stepTitleEl.textContent.trim() : ('Schritt ' + (s + 1)),
      text: textParts.join(' ')
    };
    if (imgEl && imgEl.src) step.image = imgEl.src;
    steps.push(step);
  }

  if (steps.length === 0) return;

  var howTo = {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: name,
    description: description
  };
  if (totalTime) howTo.totalTime = totalTime;
  if (tools.length) howTo.tool = tools;
  howTo.step = steps;

  var scriptTag = document.createElement('script');
  scriptTag.type = 'application/ld+json';
  scriptTag.textContent = JSON.stringify(howTo);
  document.head.appendChild(scriptTag);
})();